import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import Tiers from "@/components/Tiers";
import { Card, Loading } from "@/components/kit";

export default function Subscribe() {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [subscribing, setSubscribing] = useState(null);
  const [paymentsNotice, setPaymentsNotice] = useState(null);

  useEffect(() => {
    api.get("/subscription").then(({ data }) => setSub(data)).catch(() => setSub(null));
  }, []);

  const subscribe = async (lookup_key, key) => {
    setSubscribing(key);
    setPaymentsNotice(null);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      if (e.response?.status === 503) {
        setPaymentsNotice(e.response.data?.detail || "Payments are being configured. Please try again soon.");
      } else {
        toast.error(e.response?.data?.detail || "Could not start checkout");
      }
      setSubscribing(null);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="h-16 border-b border-zinc-200 bg-white/70 backdrop-blur-xl flex items-center px-6">
        <Logo wordmark="Optics Software" />
      </header>
      <main className="max-w-5xl mx-auto px-6 py-16" data-testid="subscribe-page">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-amber-600 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5">
            <Sparkles className="h-3.5 w-3.5" /> One last step
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-semibold text-zinc-900 mt-6">
            Choose a plan to activate your account
          </h1>
          <p className="text-zinc-500 mt-3 max-w-xl mx-auto">
            Welcome, {user?.name || user?.email}. Your workspace is ready — pick a plan to start
            forecasting. Every plan starts with a <span className="font-semibold text-zinc-700">14-day free trial</span> —
            your card is saved but not charged until day 14. Cancel anytime before then and you pay nothing.
          </p>
        </div>

        {paymentsNotice && (
          <Card className="mt-8 p-4 bg-amber-50/60 border-amber-200" testid="payments-notice">
            <div className="text-sm text-amber-800">
              <span className="font-semibold">Payments are being configured.</span> You're not charged
              and nothing is lost — please try again shortly.
            </div>
          </Card>
        )}

        <div className="mt-10">
          {sub ? <Tiers sub={sub} subscribing={subscribing} onSubscribe={subscribe} /> : <Loading />}
        </div>
        <p className="text-xs text-zinc-400 mt-6 text-center">Secure checkout by Stripe in NZD.</p>
      </main>
    </div>
  );
}
